import classplusLogo from "../../assets/Images/classplus-logo.png";
import rightArrow from "../../assets/Images/arrow-gray.png";
import { useState , useEffect } from "react";
import trackEvent from "../utils";
import { useMediaQuery } from "react-responsive";
import "./headings.css";
import posterimg from "../../assets/Images/postermodalimg.jpg";
import closemodalicon from "../../assets/Images/closemodalicon.jpeg";
import redDot from "../../assets/Images/redDot.svg";
const Headings = ({
  userInputs,
  isNumberSubmitted,
  coachingName,
  showRadarScreen,
}) => {
  // const [posterModal, setPosterModal] = useState(false)
  // const [liveNow, isLiveNow] = useState(false);
  // const isSmallScreen = useMediaQuery({ query: "(max-width: 800px)" });

  // useEffect(()=>{
  //   if(isSmallScreen) {
  //     sessionStorage.setItem("poster-triggered", true);
  //     setTimeout(() =>{
  //         if(sessionStorage.getItem("poster-triggered") === "true"){
  //           setPosterModal(true)
  //           isLiveNow(true)
  //           sessionStorage.setItem("poster-triggered", false);
  //         }
  //     },7000)
  //   }
  //  },[])
  return (
    <div className="relative overflow-hidden">
      <div className="nav-mobile-view">
      <img src={classplusLogo} alt="" className="absolute w-32 top-1 left-1" />
      {/* { liveNow && <div className="live-now-mobile" onClick={() => {
        trackEvent("convo_webinar", "click", "live");
        window.location = "https://bit.ly/eWebinarWebsiteLiveButton";
      }}>
        <img class="redLive" src={redDot} alt="" />
         <p className="live-text">Watch Demo</p>
        </div>
      } */}
      </div>
      <div className="flex flex-col justify-between w-full pt-16 px-2">
        {isNumberSubmitted && !showRadarScreen ? (
          <>
            <h3 className="text-2xl text-colorHeading font-semibold">
              <span className="border-b-4  border-colorWhite">Hi</span>,{" "}
              {coachingName}
            </h3>
            <p>We have something special in store for you</p>
          </>
        ) : showRadarScreen ? (
          <h3 className="text-2xl text-colorHeading font-semibold">
            These are the top 3{" "}
            {userInputs["youtuber-name"]
              ? "YouTubers in your category"
              : "educators in your region"}
          </h3>
        ) : (
          <>
            <h1
              className="not-italic font-bold text-2xl"
              style={{ color: "#45c5ff" }}
            >
              BECOME INDIA’S TOP EDUCATOR WITH YOUR OWN APP!
            </h1>
            <div className="flex flex-row justify-between relative w-full lowerContainer">
              <div className="text-white mt-12 text-list">
                <p className="flex items-center mb-3.5">
                  <img src={rightArrow} alt="" className="w-4 self-start" />
                  <span className="ml-2">Grow your business by 20X</span>
                </p>

                <p className="flex items-center mb-3.5">
                  <img src={rightArrow} alt="" className="w-4 self-start" />
                  <span className="ml-2">
                    Teach 1 Crore+ students nationally
                  </span>
                </p>

                <p className="flex items-center mb-3.5">
                  <img src={rightArrow} alt="" className="w-4 self-start" />
                  <span className="ml-2">
                    Earn an additional monthly income of over 2 lacs.
                  </span>
                </p>
              </div>
              <div className="absolute bg-contain bg-no-repeat z-10 right-0 sauravDadaImg" />
            </div>
          </>
        )}
      </div>
      {/* {posterModal && posterimg && <div class="poster-modal">
      <img className="poster-img" onClick={()=>window.location = "https://bit.ly/eWebinarWebsitePopup"} src={posterimg} />
       <img class="poster-modal-close" src={closemodalicon} onClick={()=>setPosterModal(false)} />
      </div>
      } */}
    </div>
  );
};

export default Headings;
